import { helpers } from '@vuelidate/validators';
import messages, { getTypes } from './messages';

export function validateName(value: string) {
  if (!value) {
    return true;
  }
  return value.match(/^([A-Za-z][A-Za-z \-.]+)$/) !== null;
}

export function validateDateOfBirth(value: string | null) {
  let isValid = false;
  if (value === '') {
    return true;
  }
  if (value?.match(/^(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])(19|20)([0-9]{2})$/)) {
    isValid = true;
  }
  return isValid;
}

export function getErrorMessages({
  vObject,
  field,
}: {
  vObject:
    Record<string, { $dirty: boolean; $error: boolean; [_key: string]: boolean }> | undefined;
  field: string;
}): string[] {
  const errors: string[] = [];
  if (!vObject?.[field].$dirty) {
    return errors;
  }
  if (vObject[field].$error) {
    // If there is an error on the field
    getTypes(field).forEach((type) => {
      if (
        !vObject[field][type] &&
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        messages[field] &&
        Object.prototype.hasOwnProperty.call(messages[field], type)
      ) {
        errors.push(messages[field][type]);
      }
    });
    if (errors.length === 0) {
      // If no messages have been added for this error
      errors.push(messages.generic.invalid);
    }
  }
  return errors;
}

export const noSpaces = helpers.regex(/^((?!\s).)*$/);

export const noInvalidSpecialChars = helpers.regex(/^((?![;'<>"&]).)*$/);

export const requireUpperLowerCase = helpers.regex(/(?=.*[a-z])(?=.*[A-Z]).*/);

export const requireNumber = helpers.regex(/\d/);

export const requireSymbol = helpers.regex(/[^a-zA-Z0-9;'<>"&]/);

export const noThreeCharsInRow = helpers.regex(/^(?!.*(.)\1\1).*$/);

export function notContainString(value: string | null, string: string) {
  if (!value || value.length === 0) {
    return true;
  }
  const lowerNewPass = value.toLowerCase();
  const lowerEmail = string.toLowerCase();
  return !lowerNewPass.includes(lowerEmail);
}
